<template>
  <div>
    <cx-slider label="对齐" :value.sync="alignmentType" :options="alignmentTypeOptions" :showToolTip="true" />
    <slider-and-input
      class="mt8"
      inputWidth="small"
      inputHeight="small"
      :value.sync="subNavMargin"
      title="间距"
      titlePosition="singleLine"
      :sliderMax="100"
      suffix="px"
    />
  </div>
</template>

<script>
import complexSetMixin from "./complexSetMixin.js"
export default {
  mixins: [complexSetMixin()],
  components: {},
  props: {
    options: Object
    // configData:undefined
  },
  data() {
    return {
      alignmentTypeOptions: [
        {
          value: "left",
          label: "左对齐",
          iconClass: "icon-portal-Align-left"
        },
        {
          value: "center",
          label: "居中对齐",
          iconClass: "icon-portal-Center-lr"
        },
        {
          value: "right",
          label: "右对齐",
          iconClass: "icon-portal-Align-right"
        }
      ],
    }
  },
  computed: {
    alignmentType:{
      get(){
        return this.configData.alignmentType
      },
      set(val){
        this.configData.alignmentType = val
      }
    },
    subNavMargin:{
      get(){
        return this.options.ulMarginTop
      },
      set(newVal){
        this.$changeOptionsEV(newVal, "ulMarginTop", false)
      }
    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style scoped lang="scss">
.lineHeight32 {
  display: inline-block;
  line-height: 32px;
}

::v-deep .el-dropdown-link {
  color: var(--subTextColor) !important;
}

::v-deep .input-size .el-input__suffix {
  right: 4px;
}

::v-deep .input-size .el-dropdown-link {
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 3px;
  margin: 4px 0;
}

::v-deep .input-size .el-dropdown-link:hover {
  background: var(--paddingIconHoverColor);
}

::v-deep .input-size.el-input.is-disabled .el-input__inner {
  background: var(--inputBackGround) !important;
}

.selected-icon {
  position: absolute;
  top: 50%;
  left: 12px;
  font-size: 16px;
  color: var(--themeColor);
  transform: translateY(-50%);
}

.dropdown-size {
  margin-top: -32px;
}

.dropdown-size li {
  position: relative;
  width: 100px;
  padding-left: 36px;
  padding-right: 12px;
}

.el-dropdown-menu__item {
  color: var(--textColor);
  font-size: 13px;
}

.title-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--textColor);
  font-size: 16px;
}

.custom-menu {
  .el-dropdown-menu__item {
    line-height: 38px;
    padding: 0 12px;

    .icon {
      display: inline-block;
      vertical-align: top;
      margin-top: 10px;
      font-size: 16px;
      margin-right: 8px;
    }
  }
}
</style>
